/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

export type SyllabusItemTitleElement = React.ReactElement<Props, typeof SyllabusItemTitle>;

type Props = {
  title: string;
  slug?: string;
  link?: string;
  linkA11yLabel?: string;
  headingLevel?: 'h2';
  disableLink?: boolean;
};

const styles = {
  link: (theme: Theme) => css`
    color: ${theme.palette.black[700]};

    /* doubling the current class to override CDS's blue color applied to visited links */
    &&:visited {
      color: ${theme.palette.black[700]};
    }

    &&:hover {
      color: ${theme.palette.blue[700]};
      text-decoration: underline;
    }
  `,
};

const SyllabusItemTitle = ({ title, link, linkA11yLabel, disableLink, slug, headingLevel }: Props) => {
  return (
    <Typography variant="h2semibold" component={headingLevel ?? 'h3'}>
      {link && !disableLink ? (
        <Link
          href={link}
          css={styles.link}
          aria-label={linkA11yLabel}
          component={TrackedLink2}
          trackingName="sdp_course_list_link"
          data-e2e="sdp-course-list-link"
          data={{
            courseName: title,
            s12nSlug: slug,
          }}
        >
          {title}
        </Link>
      ) : (
        title
      )}
    </Typography>
  );
};

export default SyllabusItemTitle;
